import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchAppData } from "./environmentAPI";

export const initialState = {
    status: "idle",
    appData: {},
    appDataLoaded: false
};

export const fetchApplicationData = createAsyncThunk(
    'app/fetchAppData',
    async () => {
        const response = await fetchAppData();
        return response.data;
    }
);

const environmentSlice = createSlice({
    name: 'environment',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
          .addCase(fetchApplicationData.pending, (state) => ({
            ...state,
            status: "loading",
            appDataLoaded: false
          }))
          .addCase(fetchApplicationData.fulfilled, (state, action) => ({
            ...state,
            status: "idle",
            appData: action.payload,
            appDataLoaded: true
          }))
          .addCase(fetchApplicationData.rejected, (state) => ({
            ...state,
            failed: true,
            status: "loading",
            appDataLoaded: true
          }));
    },
});

export const getAppData = (state) => state.environment.appData;
export const getAppDataLoaded = (state) => state.environment.appDataLoaded;

export default environmentSlice.reducer;
